import { render, staticRenderFns } from "./termsAndConditions.vue?vue&type=template&id=13aa385a&scoped=true&"
import script from "./termsAndConditions.vue?vue&type=script&lang=js&"
export * from "./termsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./termsAndConditions.vue?vue&type=style&index=0&id=13aa385a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aa385a",
  null
  
)

export default component.exports